import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-neutral-900 mb-8 text-center">
          Ship and Delivery Policy
        </h1>

        <div className="bg-white rounded-lg shadow-lg p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Shipping Methods
            </h2>
            <p className="text-neutral-700 leading-relaxed mb-6">
              At Rishabh Enterprises, we offer two convenient ways for agents to receive their FasTags:
            </p>

            <div className="space-y-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
                <div className="flex items-start">
                  <div className="bg-blue-500 text-white rounded-full p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-neutral-800 mb-2">Courier Service</h3>
                    <p className="text-neutral-700 leading-relaxed">
                      Agents can choose to have their purchased FasTags delivered via a trusted courier
                      service. Once the order is placed and payment is confirmed, the FasTags will be
                      shipped to the agent's registered address. Delivery times may vary depending on
                      the location but typically range between <strong>3-10 business days</strong>. Agents
                      will receive a tracking number once the package is dispatched, allowing them to
                      monitor the delivery status.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-green-50 border border-green-200 rounded-lg p-6">
                <div className="flex items-start">
                  <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-neutral-800 mb-2">Counter Collection</h3>
                    <p className="text-neutral-700 leading-relaxed">
                      For agents preferring to collect their FasTags in person, our counter-collection
                      service is available. Agents can visit our designated collection counters, where
                      the FasTags can be picked up. A <strong>valid ID</strong> and the <strong>purchase
                      confirmation receipt</strong> are required at the time of collection.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Delivery Charges
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-neutral-50 p-4 rounded-lg">
                <h3 className="font-semibold text-neutral-800 mb-2">Courier Service</h3>
                <p className="text-neutral-700">
                  Shipping charges are calculated based on the delivery location.
                </p>
              </div>
              <div className="bg-neutral-50 p-4 rounded-lg">
                <h3 className="font-semibold text-neutral-800 mb-2">Counter Collection</h3>
                <p className="text-neutral-700">
                  There are no additional charges for collecting FasTags from our designated counters.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Delivery Timelines
            </h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-800 mb-1">Courier Service</h3>
                  <p className="text-neutral-700">
                    Orders are processed and dispatched within 1-2 business days after confirmation.
                    Delivery typically takes between 3-10 business days depending on the location.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-neutral-800 mb-1">Counter Collection</h3>
                  <p className="text-neutral-700">
                    FasTags will be available for collection within 1-2 business days after the order
                    is confirmed.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Order Tracking
            </h2>
            <p className="text-neutral-700 leading-relaxed">
              For courier deliveries, agents will receive the tracking details once the FasTags are
              shipped. This tracking number can be used to monitor the delivery status through our
              courier partner's website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Missed Delivery
            </h2>
            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded">
              <p className="text-neutral-700 leading-relaxed">
                If a courier delivery attempt is unsuccessful, the courier service will attempt to
                redeliver the FasTags. In case the FasTags are not delivered, they will be returned
                to our facility, and agents can either arrange for redelivery or opt for
                counter-collection.
              </p>
            </div>
          </section>

          <section className="bg-neutral-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-neutral-800 mb-3">
              Contact Information
            </h2>
            <p className="text-neutral-700 leading-relaxed mb-3">
              For any shipping or delivery-related queries, agents can contact our customer service team:
            </p>
            <div className="space-y-2">
              <p className="text-neutral-700">
                <strong>Email:</strong> admin@rishabhenterprises.in
              </p>
              <p className="text-neutral-700">
                <strong>Phone:</strong> +91 81156 63423
              </p>
            </div>
          </section>

          <section className="bg-blue-50 p-6 rounded-lg">
            <p className="text-neutral-700 leading-relaxed italic">
              This policy ensures that all agents receive their FasTags in a secure and timely manner,
              allowing them to select the most convenient way of collection.
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <p className="text-neutral-600 text-sm">
            Last Updated: August 2024
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
